import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../../config/apiConfig';

export default function AdministradorImpresoras() {
    const [impresorasSistema, setImpresorasSistema] = useState([]);
    const [impresorasConfiguradas, setImpresorasConfiguradas] = useState([]);
    const [loading, setLoading] = useState(false);

    const [nuevaImp, setNuevaImp] = useState({
        nombre_amigable: '',
        nombre_sistema: '',
        imprime_comprobante: 0,
        imprime_comanda: 0,
        imprime_boleta: 0,
        activo: 1
    });

    const api_url = config.api_url.replace(/\/$/, "");

    useEffect(() => {
        cargarDatos();
    }, []);

    const cargarDatos = async () => {
        setLoading(true);
        try {
            const resSys = await axios.get(`${api_url}/api/impresoras/detectar`);
            setImpresorasSistema(resSys.data.data);
            const resConf = await axios.get(`${api_url}/api/impresoras`);
            setImpresorasConfiguradas(resConf.data.data);
        } catch (e) {
            toast.error("Error de conexión local con el servicio de impresión");
        } finally {
            setLoading(false);
        }
    };

    const guardar = async (e) => {
        e.preventDefault();
        if (!nuevaImp.nombre_amigable || !nuevaImp.nombre_sistema) {
            return toast.warning("Complete el nombre y seleccione una impresora");
        }
        
        try {
            await axios.post(`${api_url}/api/impresoras`, nuevaImp);
            toast.success("Impresora vinculada correctamente");
            setNuevaImp({ nombre_amigable: '', nombre_sistema: '', imprime_comprobante: 0, imprime_comanda: 0, imprime_boleta: 0, activo: 1 });
            cargarDatos();
        } catch (e) {
            toast.error("Error al guardar la configuración");
        }
    };

    const eliminar = async (id) => {
        if (!window.confirm("¿Desvincular esta impresora de la base de datos?")) return;
        try {
            await axios.delete(`${api_url}/api/impresoras/${id}`);
            toast.success("Impresora eliminada");
            cargarDatos();
        } catch (e) {
            toast.error("Error al eliminar");
        }
    };

    const toggleEstado = async (imp, campo, valor) => {
        try {
            await axios.put(`${api_url}/api/impresoras/${imp.id}`, { [campo]: valor });
            cargarDatos(); // Refrescar para ver los cambios
        } catch (e) {
            toast.error("No se pudo actualizar el estado");
        }
    };

    return (
        <div className="container-fluid p-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
            <div className="bg-white p-3 shadow-sm rounded mb-4 d-flex justify-content-between align-items-center">
                <h4 className="mb-0 text-primary fw-bold">
                    <i className="bi bi-printer-fill me-2"></i> Panel de Impresoras Locales
                </h4>
                <button className="btn btn-primary btn-sm" onClick={cargarDatos} disabled={loading}>
                    {loading ? 'Cargando...' : '🔄 Refrescar'}
                </button>
            </div>

            <div className="row">
                {/* Formulario Lateral */}
                <div className="col-md-4">
                    <div className="card border-0 shadow-sm mb-4">
                        <div className="card-header bg-dark text-white fw-bold">Vincular Nueva</div>
                        <div className="card-body">
                            <form onSubmit={guardar}>
                                <div className="mb-3">
                                    <label className="form-label small fw-bold">Alias (Ej: Cocina 1)</label>
                                    <input type="text" className="form-control" 
                                        value={nuevaImp.nombre_amigable} 
                                        onChange={e => setNuevaImp({...nuevaImp, nombre_amigable: e.target.value})} />
                                </div>
                                
                                <div className="mb-3">
                                    <label className="form-label small fw-bold">Impresora en Windows/Linux</label>
                                    <select className="form-select" 
                                        value={nuevaImp.nombre_sistema}
                                        onChange={e => setNuevaImp({...nuevaImp, nombre_sistema: e.target.value})}>
                                        <option value="">-- Seleccionar impresora --</option>
                                        {impresorasSistema.map((n, i) => <option key={i} value={n}>{n}</option>)}
                                    </select>
                                </div>

                                <button type="submit" className="btn btn-success w-100 fw-bold">
                                    <i className="bi bi-plus-circle me-1"></i> Vincular
                                </button>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Tabla de Gestión */}
                <div className="col-md-8">
                    <div className="card border-0 shadow-sm">
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th>Alias / Nombre</th>
                                        <th className="text-center">Activa</th>
                                        <th className="text-center">Comprobante</th>
                                        <th className="text-center">Comanda</th>
                                        <th className="text-center">Boleta</th>
                                        <th className="text-end">Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {impresorasConfiguradas.map((imp) => (
                                        <tr key={imp.id} className={imp.activo ? "" : "opacity-50"}>
                                            <td>
                                                <div className="fw-bold">{imp.nombre_amigable}</div>
                                                <div className="text-muted small">{imp.nombre_sistema}</div>
                                            </td>
                                            <td className="text-center">
                                                <div className="form-check form-switch d-inline-block">
                                                    <input className="form-check-input" type="checkbox" checked={imp.activo === 1}
                                                        onChange={(e) => toggleEstado(imp, 'activo', e.target.checked ? 1 : 0)} />
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                <button 
                                                    className={`btn btn-sm ${imp.imprime_comprobante ? 'btn-success' : 'btn-outline-secondary'}`}
                                                    onClick={() => toggleEstado(imp, 'imprime_comprobante', imp.imprime_comprobante ? 0 : 1)}
                                                >🧾</button>
                                            </td>
                                            <td className="text-center">
                                                <button 
                                                    className={`btn btn-sm ${imp.imprime_comanda ? 'btn-warning' : 'btn-outline-secondary'}`}
                                                    onClick={() => toggleEstado(imp, 'imprime_comanda', imp.imprime_comanda ? 0 : 1)}
                                                >🍳</button>
                                            </td>
                                            <td className="text-center">
                                                <button 
                                                    className={`btn btn-sm ${imp.imprime_boleta ? 'btn-info' : 'btn-outline-secondary'}`}
                                                    onClick={() => toggleEstado(imp, 'imprime_boleta', imp.imprime_boleta ? 0 : 1)}
                                                >⚖️</button>
                                            </td>
                                            <td className="text-end">
                                                <button className="btn btn-link text-danger p-0" onClick={() => eliminar(imp.id)}>
                                                    <i className="bi bi-trash3-fill fs-5"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    {impresorasConfiguradas.length === 0 && (
                                        <tr>
                                            <td colSpan="6" className="text-center py-4 text-muted">No hay impresoras vinculadas</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}